import { Reveal, Eyebrow } from "./Reveal";
import { PROCESS } from "../data/content";

export const Process = () => (
    <section id="ablauf" className="bg-mist py-20 lg:py-32" data-testid="process-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            <Reveal>
                <Eyebrow num="04" label="Ablauf" />
                <h2 className="font-display font-semibold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-[1.12] max-w-2xl">
                    In vier Schritten zum gepflegten Grundstück.
                </h2>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
                <div className="hidden lg:block absolute top-7 left-[12%] right-[12%] h-px bg-forest/15" />
                {PROCESS.map((p, i) => (
                    <Reveal key={p.step} delay={i * 0.1}>
                        <div data-testid={`process-step-${p.step}`} className="relative">
                            <div className="w-14 h-14 rounded-2xl bg-forest text-leaf-soft font-mono font-semibold flex items-center justify-center text-sm relative z-10">
                                {p.step}
                            </div>
                            <h3 className="mt-6 font-display font-semibold tracking-tight text-ink text-xl">{p.title}</h3>
                            <p className="mt-2.5 text-sm text-shade leading-relaxed">{p.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
